import { handleActions } from 'redux-actions'

const TOGGLE_DOCUMENT_SIDEBAR = 'TOGGLE_DOCUMENT_SIDEBAR'

const getInitialState = () => ({
  sidebarRightOpen: true,
})

const toggleSidebarRight = () => ({
  type: TOGGLE_DOCUMENT_SIDEBAR,
  payload: null,
})

export const actions = {
  toggleSidebarRight,
}

export default handleActions(
  {
    [TOGGLE_DOCUMENT_SIDEBAR]: state => ({
      sidebarRightOpen: !state.sidebarRightOpen,
    }),
  },
  getInitialState()
)
